<app-header></app-header>
<div class="div-contenedor-serie">
    <app-menu-alterno></app-menu-alterno>
    <div class="texto_titulo">
        <div id="titulos" style="text-align: right;">
            <div>
                <h1 class="h1-titulo-app">{{titulo}}</h1>
            </div>
            <div>
                <h4 class="h4-titulo-app">{{subtitulo}}</h4>
            </div>
        </div>
    </div>
    <div class="div-linea-titulo">
    </div>
    <div class="contenedor_grid_report_graph">

        <div class="div-columna-grafico columna-1">

            <div class="contenedor_grid_menu div-1">

                <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="cardOpcion menu_boton"
                    (click)="openDialog()">
                    <a class="myBtn">
                        <p class="p-texto-menu-app">Información sobre la(s) serie(s)</p>
                    </a>
                </div>

                <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="cardOpcion menu_boton"
                    (click)="aplicacionGraficadorSerie()">
                    <a>
                        <p class="p-texto-menu-app">Añadir series de datos</p>
                    </a>
                </div>

                <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="cardOpcion menu_boton"
                    (click)="openDialogFeErrata('DOCUMENTOS_METODOLOGICOS')">
                    <a class="myBtn">
                        <p class="p-texto-menu-app">Documentos metodológicos</p>
                    </a>
                </div>

                <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="cardOpcion menu_boton"
                    (click)="openDialogFeErrata('NOTA_ACLARATORIA')">
                    <a class="myBtn">
                        <p class="p-texto-menu-app">Notas aclaratorias y fe de erratas</p>
                    </a>
                </div>

                <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="cardOpcion menu_boton">
                    <a class="myBtn" href="https://www.banrep.gov.co/es/glosario" target="_blank">
                        <p class="p-texto-menu-app">Glosario</p>
                    </a>
                </div>
            </div>

            <!--********************************************************* PARTE 3 CONTENIDO **********************************************-->
            <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="div-boton-vista div-2">
                @if (botonTabla) {
                <button class="boton-vista-datos boton-info-serie" id="vistaTabla"
                    (click)="toggleView()">{{nombreBotonTabla}}
                </button>
                }

            </div>
            @if (grafica != '') {
            <div class="div-3">
                <app-grafica-analitica [dataSeriesDivisionGasto]="dataSeriesDivisionGasto"
                    [seccion]="seccion"></app-grafica-analitica>
            </div>
            }

            @if (mostrarChart == 'chartSeries') {
            <div [ngClass]="estiloChart" id="cardContenido" class="div-4">
                <img *ngIf="cargando" src="/estadisticas-economicas/assets/img/cargando_1.gif" class="progress-spinner">

                <div id="containerSeries" class="container-series-highcharts"></div>

                <!--div *ngIf="Highcharts && chartOptions">
                    <highcharts-chart id="chartEstadisticasBanrep" [Highcharts]="Highcharts" [options]="chartOptions"
                        style="width: 100%; height: 700px; display: block;"></highcharts-chart>
                </div-->
                <!--highcharts-chart #chartEstadisticas [Highcharts]="Highcharts" [options]="chartOptions"
                    id="chartEstadisticas" [update]="updateFlag" (chartInstance)="onChartCreated($event)" class=" ">
                </highcharts-chart-->

            </div>
            }

            @if (mostrarChart == 'mercadoCambiario') {
            <div class="cardContenido" class="div-4">
                <app-mercado-cambiario></app-mercado-cambiario>
            </div>
            }


        </div>

        <div class="cardContenido columna-2">
            <div class="cardOpcion-multicolor div-encuesta" cdkDrag [cdkDragFreeDragPosition]="dragPosition">
                <div class="menu_boton div-boton-encuesta" (click)="openDialogEncuesta()">
                    <a class="a-link-boton-encuesta">
                        <p class="p-texto-menu-app">Para mejorar, compártanos su retroalimentación</p>
                    </a>
                </div>
            </div>

            <div class="div-boton-vista">

            </div>

            <div *ngIf="mostrarChart == 'chartSeries' && grafica == ''" class="menu_tile ">
                <div class="mostrarslides-container">
                    <!--<ng-container *ngFor="let tile of tilePaginator; index as i;">-->
                    <div id="div-tile">

                        <div id="tile-reporte" class="reporteObbie">
                            <div class="tileValor">{{valor}}</div>
                            <div class="tileUnidad" id="tile-unidad">{{unidad}}</div>
                            <div class="tile-linea"></div>
                            <div class="tileNombre">{{nombre}}</div>
                            <div class="tileNombre">{{tipoTasa}}</div>
                            <div class="tilefecha">{{fecha}}</div>
                        </div>
                    </div>
                    <!--</ng-container>-->
                    <a *ngIf="tilePaginator.length > 1" class="anteriorSlide" (click)="plusSlides(-1, 0)"
                        matTooltip="Cambiar serie" matTooltipClass="tile-tooltip">&#10094;</a>
                    <a *ngIf="tilePaginator.length > 1" class="siguienteSlide" (click)="plusSlides(1, 0)"
                        matTooltip="Cambiar serie" matTooltipClass="tile-tooltip">&#10095;</a>
                </div>
            </div>

            <div class="menu_lateral_slider">
                <ul class="opcion-sub-menu-inicial">
                    <li class="li-menu-lateral li-not-selected" (click)="abrirPagina('dashboard', true)">
                        <mat-icon class="arrow_forward">arrow_forward</mat-icon>
                        <a id="dashboard_dat2" class="enlace-menu-lateral" tabindex="0"
                            [innerHTML]="'Más datos relacionados'">

                        </a>
                    </li>
                    <li class="li-menu-lateral li-not-selected">
                        <mat-icon></mat-icon>
                        <a id="catalogo_dat" class="enlace-menu-lateral" tabindex="0" (click)="abrirPagina('catalogo')"
                            [innerHTML]="constante.ETIQUETA_BOTON_CATALOGO">
                        </a>
                    </li>
                    <li class="li-menu-lateral li-not-selected">
                        <a id="graficador_dat" class="enlace-menu-lateral" tabindex="0"
                            (click)="abrirPagina('graficador')" [innerHTML]="constante.ETIQUETA_BOTON_GRAFICADOR_H">
                        </a>
                    </li>
                    <li class="li-menu-lateral li-not-selected">
                        <a id="shopping_dat" class="enlace-menu-lateral" tabindex="0" (click)="abrirPagina('shopping')"
                            [innerHTML]="constante.ETIQUETA_BOTON_BUSCADOR">
                        </a>
                    </li>
                </ul>
            </div>

        </div>

    </div>

    <div *ngIf="mostrarTabla == 'showTable'" class="div-tabla">
        <div id="divTablaDatos" class="seriecontainer">
            <div *ngFor="let participante of participantesIBR">
                <div id="{{participante.id}}-grafico" class="div-grafico-ibr" style="display: block;">

                    <div *ngIf="HighchartsIBR && participante.graficoIBR">
                        <highcharts-chart id="chartParticipantesIBR" [Highcharts]="HighchartsIBR"
                            [options]="participante.graficoIBR" style="width: 100%; display: block;"></highcharts-chart>
                    </div>

                </div>
                <div id="{{participante.id}}-tabla" class="div-tabla-ibr" style="display: none;">
                    <p class="p-titulo-ibr">{{participante.titulo}}</p>
                    <table>
                        <tbody>
                            <tr class="tr-columna-encabezado-ibr">
                                <th><span>Participante</span></th>
                                <th><span>Tasa nominal</span></th>
                            </tr>
                            <tr class="tr-columna-series-ibr" *ngFor="let entidad of participante.tablaIBR.entidades">
                                <td class="td-descripcion-ibr">{{entidad.nombre}}</td>
                                <td class="td-valor-ibr">{{entidad.valor}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div id="{{participante.id}}-buttonCP" class="div-boton-ibr" style="display: block;"><button
                        (click)="cambiarVistaTabla(participante.id,'grafica')">Cotizaciones participantes</button>
                </div>
                <div id="{{participante.id}}-buttonIBR" class="div-boton-ibr" style="display: none;"><button
                        (click)="cambiarVistaTabla(participante.id, 'tabla')">IBR</button></div>
            </div>
        </div>
    </div>
</div>